import * as React from 'react'
import { DefaultTheme } from 'styled-components'
import { injectTheme } from '../../theme'

interface Props {
  max: number
  value: number
  style?: React.CSSProperties
  withWarningColor?: boolean
}

@injectTheme
export default class ProgressBarComponent extends React.Component<Props & { theme?: DefaultTheme }, never> {
  static defaultProps: Pick<Props, 'withWarningColor'> = {
    withWarningColor: false
  }
  
  render () {
    const { max, value, style, theme, withWarningColor } = this.props

    let backgroundColor = theme.colors.clr_1

    if (withWarningColor) {
      if (value > max) {
        backgroundColor = theme.colors.clr_error
      } else if (value >= 0.8 * max) {
        backgroundColor = theme.colors.clr_warning
      }
    }

    return <div className="progressBar" style={ style }>
      <div className="progressBar-inner" style={{ width: `${100 * value / max}%`, backgroundColor }}></div>
    </div>
  }
}
